import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import AppEntry from './components/AppEntry';
import Updates from './components/Updates';
import Media from './components/Media';
import About from './components/About';
import Cards from './components/Cards';
import FAQ from './components/FAQ';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <AppEntry />
        <Updates />
        <Media />
        <About />
        <Cards />
        <FAQ />
        <Comments />
        <Topics />
        <Ranking />
        <Index />
        <Carousel />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}